import { useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { adjustToNYTime, getCurrentTimeNY } from '../helpers/date-helpers';
import { TcsmSiteSettingsProps } from '../models/epi-model';

const defaultYear = '0001';
export const useMyCpgMaintenance = () => {

	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state?.epiProps?.siteSettingsState?.siteSettings);
	const currentTime = getCurrentTimeNY()?.getTime();
	const hasStartTime = siteSettings?.myCpgMaintenanceStartTime && !siteSettings?.myCpgMaintenanceStartTime?.includes(defaultYear);
	const hasEndTime = siteSettings?.myCpgMaintenanceEndTime && !siteSettings?.myCpgMaintenanceEndTime?.includes(defaultYear);
	if (hasStartTime && !hasEndTime) {
		return currentTime >= adjustToNYTime(new Date(siteSettings?.myCpgMaintenanceStartTime)).getTime();
	}
	if (!hasStartTime && hasEndTime) {
		return adjustToNYTime(new Date(siteSettings?.myCpgMaintenanceEndTime)).getTime() >= currentTime;
	}
	if (hasStartTime && hasEndTime) {
		return currentTime >= adjustToNYTime(new Date(siteSettings?.myCpgMaintenanceStartTime)).getTime() && currentTime <= adjustToNYTime(new Date(siteSettings?.myCpgMaintenanceEndTime)).getTime();
	}

	return false;
};

export const useMapMaintenance = () => {

	const siteSettings = useSelector<TcsmStates, TcsmSiteSettingsProps>(state => state?.epiProps?.siteSettingsState?.siteSettings);
	const currentTime = getCurrentTimeNY()?.getTime();
	const hasStartTime = siteSettings?.mapMaintenanceStartTime && !siteSettings?.mapMaintenanceStartTime?.includes(defaultYear);
	const hasEndTime = siteSettings?.mapMaintenanceEndTime && !siteSettings?.mapMaintenanceEndTime?.includes(defaultYear);
	if (hasStartTime && !hasEndTime) {
		return currentTime >= adjustToNYTime(new Date(siteSettings?.mapMaintenanceStartTime)).getTime();
	}
	if (!hasStartTime && hasEndTime) {
		return adjustToNYTime(new Date(siteSettings?.mapMaintenanceEndTime)).getTime() >= currentTime;
	}
	if (hasStartTime && hasEndTime) {
		return currentTime >= adjustToNYTime(new Date(siteSettings?.mapMaintenanceStartTime)).getTime() && currentTime <= adjustToNYTime(new Date(siteSettings?.mapMaintenanceEndTime)).getTime();
	}

	return false;
};